export default __webpack_public_path__ + "static/media/sun-horizon-3.a5a65fe7.svg";